import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "remember-forget" }
const _hoisted_3 = { class: "third-party-login" }

import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  import h5Config from '@/config/config';

  // 初始化数据
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

_useCssVars(_ctx => ({
  "1068c6ae": (_unref(h5Config).themeColor)
}))

  const username = ref('');
  const password = ref('');
  const rememberPassword = ref(false);

  // 路由实例
  const router = useRouter();

  // 处理登录逻辑
  const handleLogin = () => {
    // 这里可以添加登录请求逻辑
    console.log('登录:', username.value, password.value);
  };

  // 忘记密码处理
  const forgetPassword = () => {
    // 这里可以添加忘记密码逻辑
    console.log('忘记密码');
  };

  // 微信登录处理
  const loginWithWechat = () => {
    // 这里可以添加微信登录逻辑
    console.log('微信登录');
  };

  // 手机登录处理
  const loginWithPhone = () => {
    // 这里可以添加手机登录逻辑
    console.log('手机登录');
  };

  // 跳转到注册页面
  const goToRegister = () => {
    router.push('/register');
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h1", null, "账号登录", -1)),
    _createVNode(_component_van_field, {
      modelValue: username.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
      label: "用户名/手机号",
      placeholder: "请输入用户名或手机号",
      class: "input-field"
    }, {
      label: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "contact",
          size: "30"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
      type: "password",
      label: "密码",
      placeholder: "请输入密码",
      class: "input-field"
    }, {
      label: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "lock",
          size: "30"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_checkbox, {
        modelValue: rememberPassword.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rememberPassword).value = $event))
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("记住密码")
        ])),
        _: 1,
        __: [3]
      }, 8, ["modelValue"]),
      _createElementVNode("span", { onClick: forgetPassword }, "忘记密码?")
    ]),
    _createVNode(_component_van_button, {
      type: "primary",
      block: "",
      class: "custom-button",
      onClick: handleLogin
    }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode("登 录")
      ])),
      _: 1,
      __: [4]
    }),
    _createElementVNode("div", _hoisted_3, [
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "或通过以下方式登录", -1)),
      _createVNode(_component_van_icon, {
        name: "wechat",
        size: "30",
        color: "#07c160",
        onClick: loginWithWechat
      }),
      _createVNode(_component_van_icon, {
        name: "phone",
        size: "30",
        color: "#ff4444",
        onClick: loginWithPhone
      })
    ]),
    _createElementVNode("p", { class: "register-link" }, [
      _cache[6] || (_cache[6] = _createTextVNode("还没有账号? ")),
      _createElementVNode("a", {
        href: "#",
        onClick: goToRegister
      }, "立即注册")
    ])
  ]))
}
}

})